import React from 'react';
import styled from 'styled-components';

import { ModalContainer, ModalButton, ModalSecondaryHeader, ModalClose, ModalCopy } from 'shared/modals';

type BaseCustomNavigationModalProps = {
  children?: React.ReactNode;
  childrenLabel?: string;
  copy: string;
  handleSave: () => void;
  headerText: string;
  inputLabel: string;
  isEditing: boolean;
  isOpen: boolean;
  isValid: boolean;
  onClose: () => void;
  setLabel: (value: string) => void;
};

export function BaseCustomNavigationModal({
  children,
  childrenLabel,
  copy,
  handleSave,
  headerText,
  onClose,
  inputLabel,
  isEditing,
  isOpen,
  isValid,
  setLabel,
}: BaseCustomNavigationModalProps): JSX.Element {
  return (
    <ModalContainer isOpen={isOpen} padding='30px 24px 52px' width='min(462px, calc(100vw - 32px))'>
      <ModalSecondaryHeader lowercase>
        {isEditing ? 'Edit' : 'Add a'} {headerText}
      </ModalSecondaryHeader>
      <Copy>{copy}</Copy>

      {children && (
        <FieldContainer>
          <Label>{childrenLabel ?? headerText}</Label>
          {children}
        </FieldContainer>
      )}

      <FieldContainer>
        <Label>Label*</Label>
        <StyledInput
          autoFocus
          value={inputLabel}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLabel(e.target.value)}
          placeholder='Enter navigation item label'
        />
      </FieldContainer>

      <ModalButton mt='30px' width='82px' onClick={handleSave} disabled={!isValid}>
        {isEditing ? 'Save' : 'Add'}
      </ModalButton>

      <ModalClose onClick={onClose} />
    </ModalContainer>
  );
}

const Copy = styled(ModalCopy)`
  margin-bottom: 24px;
`;

const FieldContainer = styled.div`
  margin-bottom: 16px;
  width: 100%;
`;

const Label = styled.label`
  color: #969ea5;
  display: block;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
  text-transform: uppercase;
`;

export const StyledInput = styled.input`
  border: 1px solid #d3d8de;
  border-radius: 4px;
  color: #4f5d68;
  font-size: 13px;
  height: 45px;
  padding: 0 16px;
  width: 100%;

  &:focus {
    border-color: #0b99e6;
    outline: none;
  }
`;
